import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../components/Home/Home';

// Lazy-loaded route components for optimal initial bundle performance
const ProductsGrid = lazy(() => import('../components/products/ProductsGrid'));
const ProductDetails = lazy(() => import('../components/products/ProductDetails'));
const About = lazy(() => import('../components/About/About'));
const Contact = lazy(() => import('../components/Contact/Contact'));
const Blogs = lazy(() => import('components/Blogs/Blogs'));
const BlogDetails = lazy(() => import('components/Blogs/BlogDetails'));
const Event = lazy(() => import('components/Events/Event'));
const EventDetails = lazy(() => import('components/Events/EventDetails'));
const Policy = lazy(() => import('components/Policy & Terms/Policy'));
const Terms = lazy(() => import('components/Policy & Terms/Terms'));
const ImageGallery = lazy(() => import('../components/products/ImageGallery'));

const PageLoader = () => (
    <div className="min-h-[50vh] flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#814c26]/20 border-t-[#814c26] rounded-full animate-spin"></div>
    </div>
);

const AppRoutes = () => {
    return (
        <Suspense fallback={<PageLoader />}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Home" element={<Home />} />
                <Route path="/Products" element={<ProductsGrid />} />
                <Route path="/laminates" element={<ProductsGrid />} />
                <Route path="/acrylic" element={<ImageGallery category="Acrylic" />} />
                <Route path="/louvers" element={<ImageGallery category="Louvers" />} />
                <Route path="/products/:slug" element={<ProductDetails />} />
                <Route path="/laminates/:slug" element={<ProductDetails />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/:slug/" element={<ProductDetails />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/:slug" element={<BlogDetails />} />
                <Route path="/events" element={<Event />} />
                <Route path="/event-post/:slug" element={<EventDetails />} />
                <Route path="/policy" element={<Policy />} />
                <Route path="/terms" element={<Terms />} />
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;

